export default __webpack_public_path__ + "static/media/view_more.8305105e.svg";